class SiblingsProducts extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('.product__siblings-grid');
    this.toggleButton = this.querySelector('.product__siblings-toggle');
    this.handleToggle = this.handleToggle.bind(this);

    if (!this.grid) return;

    this.toggleButton?.addEventListener('click', this.handleToggle);
    this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
    this.resizeObserver.observe(this);
    this.queueUpdate();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.toggleButton?.removeEventListener('click', this.handleToggle);
    cancelAnimationFrame(this.animationFrame);
  }

  handleToggle() {
    const isExpanded = this.classList.toggle('is-expanded');
    this.toggleButton.setAttribute('aria-expanded', isExpanded);
  }

  queueUpdate() {
    cancelAnimationFrame(this.animationFrame);
    this.animationFrame = requestAnimationFrame(() => this.updateRows());
  }

  updateRows() {
    const items = [...this.grid.querySelectorAll('.product__siblings-item')];

    items.forEach((item) => {
      item.classList.remove('product__siblings-item--preview', 'product__siblings-item--hidden');
    });

    const firstRowTop = items[0]?.offsetTop;
    const secondRowTop = items.find((item) => item.offsetTop > firstRowTop + 1)?.offsetTop;

    items.forEach((item) => {
      if (secondRowTop === undefined) return;

      if (item.offsetTop === secondRowTop) {
        item.classList.add('product__siblings-item--preview');
      } else if (item.offsetTop > secondRowTop) {
        item.classList.add('product__siblings-item--hidden');
      }
    });

    if (this.toggleButton) {
      const hasSecondRow = secondRowTop !== undefined;

      this.toggleButton.hidden = !hasSecondRow;
      if (!hasSecondRow) {
        this.classList.remove('is-expanded');
        this.toggleButton.setAttribute('aria-expanded', 'false');
      }
    }
  }
}

if (!customElements.get('siblings-products')) {
  customElements.define('siblings-products', SiblingsProducts);
}
